import { render, staticRenderFns } from "./PriceListAdd.vue?vue&type=template&id=49ef3ccb&"
import script from "./PriceListAdd.vue?vue&type=script&lang=js&"
export * from "./PriceListAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports